import "../../../App.css";
import {Descriptions, Layout, Radio, Typography} from "antd";
import "antd/dist/reset.css";
import {PaymentType} from "../../../App";
import WrappedCard from "../../antd/WrappedCard";
import {CardTypeEnum} from "../../../types/CardTypeEnum";
import {Copyable} from "../../common/Copyable";
import {useState} from "react";

const {Content} = Layout;

function PkPaymobMode({getCheckoutInfoData}: PaymentType) {

    // NOTICE: ant design
    const [selectedCardType, setSelectedCardType] = useState(CardTypeEnum.EasyPaisa)

    const url = getCheckoutInfoData?.reserved1;
    const urlArray = url.split(";");

    // iframe路径于 response.reserved1, 以;分割, 第一个为JazzCash的内嵌路径, 第二个为EasyPaisa
    const urlMap = {
        [CardTypeEnum.EasyPaisa]: urlArray[1],
        [CardTypeEnum.JazzCash]: urlArray[0],
        [CardTypeEnum.JazzCashV2]: urlArray[5],
        [CardTypeEnum.Ajar]: urlArray[2],
        [CardTypeEnum.AjarToEasyPaisa]: urlArray[3],
        [CardTypeEnum.AjarToJazzCash]: urlArray[4],
        [CardTypeEnum.BankCard]: urlArray[6],
        [CardTypeEnum.SadapayCard]: urlArray[7],
        [CardTypeEnum.OpayCard]: urlArray[8],
        [CardTypeEnum.Sahulatpay]: urlArray[9],
        [CardTypeEnum.SahulatpayToEasyPaisa]: urlArray[10],
        [CardTypeEnum.SahulatpayToJazzCash]: urlArray[11],
        [CardTypeEnum.EasyPaisaQRCode]: urlArray[12],
        [CardTypeEnum.JazzCashQRCode]: urlArray[13],
    };

    return (
        <>
            <Content>
                <WrappedCard cardTitle="Information">
                    <Descriptions title="Amount" bordered>
                        <Descriptions.Item label="Amount Payable">
                            <Typography.Title copyable={{icon: <Copyable/>}} level={5} style={{margin: 0}}>
                                {getCheckoutInfoData?.orderAmount}
                            </Typography.Title>
                        </Descriptions.Item>
                    </Descriptions>
                </WrappedCard>

                <WrappedCard>
                    <div style={{marginBottom: "20px"}}>
                        <span>Payment Type: </span>
                        <Radio.Group optionType="button" buttonStyle="solid" value={selectedCardType}
                                     onChange={e => setSelectedCardType(e.target.value)}>
                            <Radio.Button value={CardTypeEnum.EasyPaisa}>
                                EasyPaisa
                            </Radio.Button>
                            <Radio.Button value={CardTypeEnum.JazzCash}>
                                JazzCash
                            </Radio.Button>
                        </Radio.Group>
                    </div>
                    <iframe
                        title="checkout"
                        style={{border: 0, height: "750px", width: "100%", overflow: "hidden"}}
                        scrolling="no"
                        src={urlMap[selectedCardType]}
                    >
                    </iframe>
                </WrappedCard>
            </Content>
        </>
    );
}

export default PkPaymobMode;
